import { Ref } from 'vue';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import { report } from '@/libs/report';
import { FeedReportOpt } from '@/types/feed';
import { ModelMetaFeed } from '@/types/model';
import { useStore } from '@/store/index';
import { IS_SSR } from '@/utils/env';

type Params = {
  showRecInPlayPage: Ref<boolean>,
  activeFeedReportOpt: Ref<FeedReportOpt>,
  activeFeed: Ref<ModelMetaFeed>,
  feedsList: Ref<ModelMetaFeed[]>
};
export default function useCollectionContainerReport(params: Params) {
  const { showRecInPlayPage, activeFeedReportOpt, activeFeed } = params;
  const { info: urlInfo } = useProvideUrlInfo();
  const { collectionid: collectionId, themeid: collectionThemeId } = urlInfo.query || {};
  const store = useStore();
  const { state } = store;
  const { isNewUI, growthTestData, isCollection } = state;
  const collectionContainerReport = {
    mountedReport() {
      if (IS_SSR) return;
      report('collection.back.exposure', { ...activeFeedReportOpt.value });
      if (!isNewUI) report('collection.fold.exposure', { ...activeFeedReportOpt.value });
    },
    onClickCheckLastCollection() {
      if (showRecInPlayPage.value) {
        report('more.video.click', { ...activeFeedReportOpt.value });
        return;
      }
      report('collection.back.click', { ...activeFeedReportOpt.value });
    },
    onClickCollectionItem(feed: ModelMetaFeed, index: number) {
      if (isNewUI) {
        report(`collection.video.${index + 1}.click`, {
          ...activeFeedReportOpt.value,
          type: {
            collection_id: collectionId,
            collection_theme_id: collectionThemeId,
            feed_id: feed.id,
            is_new: growthTestData?.collectionPullNew ? 1 : 2,
            is_call: growthTestData?.collectionPullOld ? 1 : 2,
            truexp: growthTestData?.strategyID ? 1 : 2,
            collection_style: 2,
          },
        });
      } else if (isCollection) {
        report(`collection.video.${index + 1}.click`, {
          ...activeFeedReportOpt.value,
          type: {
            collection_id: collectionId,
            collection_theme_id: collectionThemeId,
            feed_id: feed.id,
            is_new: growthTestData?.collectionPullNew ? 1 : 2,
            is_call: growthTestData?.collectionPullOld ? 1 : 2,
            truexp: growthTestData?.strategyID ? 1 : 2,
            collection_style: 1,
          },
        });
      } else {
        // 老ui中，不是精选集而是页面内推荐视频的情况
        report('hot.video.play.click', {
          ...activeFeedReportOpt.value,
          type: {
            feed_id: activeFeed.value.id,
            is_new: growthTestData?.modulePullNew ? 1 : 2,
            is_call: growthTestData?.modulePullOld ? 1 : 2,
            is_newSource: growthTestData?.moduleDataSrc,
            truexp: growthTestData?.strategyID ? 1 : 2,
          },
        });
      }
    },
  };
  return collectionContainerReport;
}
